import React from 'react'

const ModalFooter = (props) => {
    return (
        <div className="flex flex-shrink-0 items-center justify-end gap-3 px-6 pt-6 pb-8 rounded-b">
            {props.children}
        </div>
    )
}

export default ModalFooter